/**
 * @file CartNumberField.tsx
 * @description Число «Вида корзины» с ползунком (phase19.16, SB120 этап 4;
 * uiux-cart §4): общее поле `NumberSliderField` с умолчанием «как сейчас»
 * (↺), живым показом на канве во время перетаскивания и предупреждениями
 * `cartLookWarnings` под полем по пути. Все числа корзины — целые.
 */

import type { SiteCart } from "@chaiberi/shared";

import { NumberSliderField } from "../../site-fields/NumberSliderField";
import type { NumberPreset } from "../../site-fields/NumberPresets";
import { useCartLook } from "./cart-look-context";
import { CartWarnings } from "./CartWarnings";
import type { NumberUnit } from "../../../lib/site-fields/number-input";

interface Props {
  label: string;
  /** Путь поля в теме (`cart.drawer.widthPhone`) — для предупреждений. */
  path: string;
  value: number;
  min: number;
  max: number;
  /** Умолчание «как сейчас» — значение «↺». */
  def: number;
  unit: NumberUnit;
  presets?: readonly NumberPreset[];
  hint?: string;
  largeStep?: number;
  /** Правка раздела из числа: `(v) => ({ drawer: { ...cart.drawer, widthPhone: v } })`. */
  patch: (value: number) => Partial<SiteCart>;
}

export function CartNumberField({ label, path, value, min, max, def, unit, presets, hint, largeStep, patch }: Props) {
  const { change, preview, readOnly } = useCartLook();
  return (
    <div className="flex min-w-0 flex-col gap-2">
      <NumberSliderField
        label={label}
        value={value}
        inherit={{ value: def, label: unit ? `${def} ${unit}` : String(def) }}
        min={min}
        max={max}
        step={1}
        integer
        largeStep={largeStep}
        unit={unit}
        presets={presets}
        hint={hint}
        disabled={readOnly}
        onChange={(v) => change(patch(v ?? def))}
        onPreview={(v) => preview(patch(v ?? def))}
      />
      <CartWarnings path={path} />
    </div>
  );
}
